// containers/LazyContainers.js
const containers = {
    AboutPage: () => import('./AboutPage'),
    ArticlePage: () => import('./ArticlePage'),
    ArticleIndexPage: () => import('./ArticleIndexPage'),
    AuthorPage: () => import('./AuthorPage'),
    AuthorsPage: () => import('./AuthorsPage'),
    BasePage: () => import('./BasePage'),
    ContactPage: () => import('./ContactPage'),
    CategoriesPage: () => import('./CategoriesPage'),
    TopicPage: () => import('./TopicPage'),
    //DevPage: () => import('./DevPage'),
    //DevIndexPage: () => import('./DevIndexPage'),
    FendAppPage: () => import('./FendAppPage'),
    FictionaryPage: () => import('./FictionaryPage'),
    FictionaryIndexPage: () => import('./FictionaryIndexPage'),
    HomePage: () => import('./HomePage'),
    PlatformPage: () => import('./PlatformPage'),
    ProjectPage: () => import('./ProjectPage'),
    ProjectIndexPage: () => import('./ProjectIndexPage'),
    MemberArticleIndexPage: () => import('./Member/MemberArticleIndexPage'),
    MemberAboutPage: () => import('./Member/MemberAboutPage'),
    MemberContactPage: () => import('./Member/MemberContactPage'),
    KnowledgeHubPage: () => import('./Knowledge/KnowledgeHubPage'),
    KnowledgeArticleIndexPage: () => import('./Knowledge/KnowledgeArticleIndexPage'),
    KnowledgeSectionPage: () => import('./Knowledge/KnowledgeSectionPage'),
    KnowledgeAboutPage: () => import('./Knowledge/KnowledgeAboutPage'),
    KnowledgePage: () => import('./Knowledge/KnowledgePage'),
    SectionIndexPage: () => import('./SectionIndexPage'),
    SectionContentPage: () => import('./SectionContentPage'),
    SectionLandingPage: () => import('./SectionLandingPage'),
    //ToolIndexPage: () => import('./ToolIndexPage'),
    ToolPage: () => import('./ToolPage'),
    UtilityPage: () => import('./UtilityPage'),
    NotFoundPage: () => import('./NotFoundPage'),
    PasswordProtectedPage: () => import('./PasswordProtectedPage'),
    PureHtmlPage: () => import('./PureHtmlPage'),
    LoginPage: () => import('./Auth/LoginPage'),
    RegisterPage: () => import('./Auth/RegisterPage'),
    ProfilePage: () => import('./Auth/ProfilePage'),
    PasswordResetPage: () => import('./Auth/PasswordResetPage'),
    PasswordResetConfirmPage: () => import('./Auth/PasswordResetConfirmPage'),
    EmailVerificationPage: () => import('./Auth/EmailVerificationPage'),
    VerificationSentPage: () => import('./Auth/VerificationSentPage'),
};

export default containers;